module.exports = __webpack_public_path__ + "static/media/testimonial-7.0f97c6f8.png";